





























import { Vue, Component, Prop } from "vue-property-decorator";
import State from "@/state";

export interface ButtonData {
  text: string;
  response: State;
}

@Component({})
export default class Question extends Vue {
  @Prop({ required: true }) readonly text!: string;
  @Prop({ required: true }) readonly buttons!: ButtonData[];
  @Prop({ required: true }) readonly hasBackButton!: boolean;

  private backButton = { text: "stateMachine.back", response: State.Back };
}
